module.exports = __webpack_public_path__ + "img/service-10.45a6c9db.svg";